import Swiper from 'swiper';

// init Swiper:
new Swiper('.events-carousel__carousel', {
  slidesPerView: 'auto',
  spaceBetween: 30,
  watchOverflow: true,
  navigation: {
    nextEl: '.events-carousel__navigation .swiper-button-next',
    prevEl: '.events-carousel__navigation .swiper-button-prev',
  },
  pagination: {
    el: '.events-carousel__navigation .swiper-pagination',
    clickable: true,
  },
});
